<div id="gallery" class="inner-page">
  <div class="container-fluid px-lg-5">
    
    <!-- ── FOLDERS VIEW ───────────────────────────────── -->
    <div *ngIf="currentView === 'folders'">
      <div class="gallery-header text-center mb-5 animate__animated animate__fadeIn">
        <h2 class="title text-center">Photo Gallery</h2>
        <div class="title-underline"></div>
        <p class="inner-lead mt-3 text-center mx-auto" style="max-width: 800px;">
          Witness the vibrant campus life, academic achievements, and cultural celebrations at Shah Satnam Ji Girls' College through our organized photo folders.
        </p>
      </div>

      <!-- Folders Grid -->
      <div class="folders-grid mb-5">
        <div class="folder-card-wrapper" *ngFor="let folder of allFolders">
          <div class="folder-card shadow-sm" (click)="selectFolder(folder.id)">
            <!-- Folder Cover Image -->
            <div class="folder-img-wrapper">
              <img [src]="folder.coverImage" [alt]="folder.name" class="img-fluid folder-img" loading="lazy" onerror="this.src='assets/img/logo/logo1.png'">
              <div class="folder-badge">
                <i class="fas fa-images me-1"></i> {{ getFolderImageCount(folder.id) }} Photos
              </div>
              <div class="folder-overlay">
                <span class="explore-btn"><i class="fas fa-folder-open me-2"></i> Explore Folder</span>
              </div>
            </div>
            <!-- Folder Info -->
            <div class="folder-info p-4">
              <h4 class="fw-bold mb-2">{{ folder.name }}</h4>
              <p class="mb-0 text-muted">{{ folder.description }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- ── PHOTOS VIEW ────────────────────────────────── -->
    <div *ngIf="currentView === 'photos'" class="animate__animated animate__fadeIn">
      <!-- Gallery Header / Breadcrumb -->
      <div class="d-flex flex-wrap align-items-center justify-content-between gap-3 border-bottom pb-4 mb-5">
        <div class="photos-header-left">
          <button type="button" class="back-btn mb-2" (click)="goBackToFolders()">
            <i class="fas fa-arrow-left me-2"></i> Back to Folders
          </button>
          <h2 class="title mb-0 mt-2">{{ selectedFolderName }}</h2>
        </div>
        <div class="photos-header-right">
          <span class="badge bg-secondary py-2 px-3 rounded-pill text-uppercase tracking-wider">
            Category: {{ selectedFolderId }}
          </span>
        </div>
      </div>

      <!-- Gallery Grid -->
      <div class="gallery-custom-grid mb-5">
        <div class="gallery-item-col" 
             *ngFor="let img of filteredImages; let i = index">
          <div class="gallery-item-card shadow-sm" (click)="openLightbox(i)">
            <div class="gallery-img-wrapper">
              <img [src]="img.src" [alt]="img.title" class="img-fluid gallery-img" loading="lazy" onerror="this.src='assets/img/logo/logo1.png'">
              <div class="gallery-card-overlay">
                <span class="category-badge">{{ img.category | uppercase }}</span>
                <div class="overlay-icon">
                  <i class="fas fa-search-plus"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Empty State -->
      <div class="text-center py-5 my-5" *ngIf="filteredImages.length === 0">
        <i class="fas fa-image fa-4x text-muted mb-3"></i>
        <h4 class="text-muted">No images found in this folder</h4>
      </div>
    </div>

    <!-- Lightbox Modal -->
    <div class="lightbox-overlay" *ngIf="lightboxOpen" (click)="closeLightbox()">
      <!-- Close Button -->
      <button class="lightbox-close-btn" (click)="closeLightbox()" aria-label="Close Lightbox">
        <i class="fas fa-times"></i>
      </button>

      <!-- Prev Button -->
      <button class="lightbox-nav-btn prev" (click)="prevImage($event)" aria-label="Previous Image">
        <i class="fas fa-chevron-left"></i>
      </button>

      <!-- Next Button -->
      <button class="lightbox-nav-btn next" (click)="nextImage($event)" aria-label="Next Image">
        <i class="fas fa-chevron-right"></i>
      </button>

      <!-- Lightbox Main Box -->
      <div class="lightbox-container" (click)="$event.stopPropagation()">
        <div class="lightbox-content">
          <div class="lightbox-img-wrapper">
            <img [src]="filteredImages[currentImageIndex]?.src" 
                 [alt]="filteredImages[currentImageIndex]?.title" 
                 class="lightbox-img"
                 onerror="this.src='assets/img/logo/logo1.png'">
          </div>
        </div>
      </div>
    </div>

  </div>
</div>
